import { render, staticRenderFns } from "./treatment.vue?vue&type=template&id=3bcd4f65&scoped=true"
import script from "./treatment.vue?vue&type=script&lang=js"
export * from "./treatment.vue?vue&type=script&lang=js"
import style0 from "./treatment.vue?vue&type=style&index=0&id=3bcd4f65&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcd4f65",
  null
  
)

export default component.exports